import { useTranslation } from 'react-i18next';

const defaultRef = {
  UNKNOWN_ACCESS: 0,
  ACCESS: 1,
  PARTIAL_ACCESS: 2,
  SUPPORT_ACCESS: 3,
  NO_ACCESS: 4,
};

export const convertAccBadgeInfo = (acc, ref) => {
  const {t} = useTranslation();
  const refUsed = ref ?? defaultRef;
  switch (acc) {
    case refUsed.UNKNOWN_ACCESS:
      return  {
        label: t('stepPath.label-acc-unknownaccess'),
        color: '#686868', 
        laColor: '#FFFFFF'
      };
    case refUsed.ACCESS:
      return  {
        label: t('stepPath.label-acc-access'),
        color: '#6ba328', 
        laColor: '#262222'
      };
    case refUsed.PARTIAL_ACCESS:
      return  {
        label: t('stepPath.label-acc-partaccess'),
        color: '#d4901e', 
        laColor: '#262222'
      };
    case refUsed.SUPPORT_ACCESS:
      return  {
        label: t('stepPath.label-acc-supportaccess'),
        color: '#FF8C00', 
        laColor: '#000000'
      };
    case refUsed.NO_ACCESS:
      return  {
        label:t('stepPath.label-acc-noaccess'),
        color: '#EE0125', 
        laColor: '#FFFFFF'
      };
    default:
      return {
        label: t('stepPath.label-acc-default'),
        color: '#000000', 
        laColor: '#FFFFFF'
      };                                 
  }
};